import React, { FC, ReactNode } from 'react'
import { TopToolbar } from '~m/designSystem'
import { QuickSearchButton } from '~m/AppUi/components/QuickSearchButton.tsx'
import styles from './SecondaryLayoutWithActions.module.css'
import { ErrorBoundary } from '~m/AppUi/components/ErrorBoundary.tsx'
import cx from 'classnames'

interface SecondaryLayoutWithActionsProps {
  className?: string
  heading: string
  toolbar?: ReactNode
  actionsDrawer: ReactNode
  hasContentPadding?: boolean
}

export const SecondaryLayoutWithActions: FC<
  React.PropsWithChildren<SecondaryLayoutWithActionsProps>
> = ({
  className,
  heading,
  toolbar,
  actionsDrawer,
  hasContentPadding,
  children,
}) => {
  return (
    <div
      className={cx(
        styles.SecondaryLayoutWithActions,
        className
      )}
    >
      <div
        className={
          styles.SecondaryLayoutWithActions__centerPanel
        }
      >
        <TopToolbar heading={heading}>
          <QuickSearchButton />
          {toolbar}
        </TopToolbar>
        <div
          className={cx(
            styles.SecondaryLayoutWithActions__content,
            {
              [styles.SecondaryLayoutWithActions__contentHasPadding]:
                hasContentPadding,
            }
          )}
        >
          <ErrorBoundary>{children}</ErrorBoundary>
        </div>
      </div>
      <ErrorBoundary>{actionsDrawer}</ErrorBoundary>
    </div>
  )
}
